<div class="organization-chart__container">
	<div class="organization-chart__block">
	</div>
	<div class="organization-chart__toolbox common-toolbox__container">
		<div class="common-toolbox__inner-container">
			<button class="common-button__icon-md-noborder"
        [pTooltip]="'organization-chart.zoom-in' | afTranslate"
        tooltipPosition="top"
				(click)="zoomWithButton('increment')">
				<i class="lf-icon-zoom-in common-icon__md"></i>
			</button>
			<button class="common-button__icon-md-noborder"
        [pTooltip]="'organization-chart.zoom-out' | afTranslate"
        tooltipPosition="top"
				(click)="zoomWithButton('decrement')">
				<i class="lf-icon-zoom-out common-icon__md"></i>
			</button>
		</div>
		<div class="common-toolbox__separator">
		</div>
		<div class="common-toolbox__inner-container">
			<button class="common-button__icon-md-noborder"
        [pTooltip]="'organization-chart.center-graph' | afTranslate"
        tooltipPosition="top"
				(click)="centerGraph()">
				<i class="lf-icon-map-marker common-icon__md"></i>
			</button>
			<button class="common-button__icon-md-noborder"
        [pTooltip]="'organization-chart.establish-graph' | afTranslate"
        tooltipPosition="top"
				(click)="showMySelf()">
				<i class="lf-icon-visible common-icon__md"></i>
			</button>
		</div>
		<div class="common-toolbox__separator">
		</div>
		<div class="common-toolbox__inner-container">
			<button class="common-button__icon-md-noborder"
        [pTooltip]="'organization-chart.expand-all' | afTranslate"
        tooltipPosition="top"
				(click)="expandAll()">
				<i class="lf-icon-reorganize common-icon__md"></i>
			</button>
		</div>
		<div class="common-toolbox__separator">
		</div>
		<div class="common-toolbox__inner-container">
			<button class="common-button__icon-md-noborder"
        [pTooltip]="'common.export' | afTranslate"
        tooltipPosition="top"
				(click)="exportToImg()">
				<i class="lf-icon-send common-icon__md"></i>
			</button>
		</div>
	</div>
</div>
